<template>
  <generic-container
    :title="$t('groups')"
    icon="boxes"
    :show_refresh="true"
    :show_plus="true"
    @refresh="init"
    @add="add"
  >
    <table
      class="ui celled very compact selectable striped table"
      ref="table"
      style="width: 100%"
    >
      <thead>
        <tr>
          <th>{{ $t("group name") }}</th>
          <th>{{ $t("options") }}</th>
        </tr>
      </thead>
      <tbody></tbody>
    </table>
  </generic-container>
</template>

<script>
import GenericContainer from "@/components/GenericContainer.vue";
import {
  local_api,
  //   enterprise_setup,
  init_ajax_data_datables,
  error_toast,
  success_toast,
  register_listener,
} from "@/utils";

export default {
  name: "AutomationEnginesConfigureModal",
  components: {
    GenericContainer,
  },
  methods: {
    init() {
      let vm = this;
      let onSelect = (/* data */) => {
        // vm.select_product(data);
      };

      let columns = [
        {
          data: function (row) {
            // console.log(row);
            return row.name;
          },
        },
        {
          data: function (row) {
            return `<div class="ui orange mini icon button" data-uuid="${row.uuid}" onclick="window.jQuery(window).trigger('modul.edit_group', this);"><i class="write icon"></i></div>
                    <div class="ui red mini icon button" data-uuid="${row.uuid}" onclick="window.jQuery(window).trigger('modul.delete_group', this);"><i class="trash icon"></i></div>`;
          },
        },
      ];

      vm.table = init_ajax_data_datables(
        vm,
        vm.$refs.table,
        window.jQuery.fn.api.settings.api["automation group url"],
        columns,
        onSelect,
      );

      setTimeout(() => {
        register_listener("modul.edit_group", function (e, element) {
          let uuid = window.jQuery(element).data("uuid");
          console.log(window.jQuery(element));
          let table_data = vm.table.rows().data();
          let final_data = [];
          for (element in table_data) {
            try {
              let isNan = isNaN(element);
              if (!isNan) final_data.push(table_data[element]);
            } catch (error) {
              console.error(error);
            }
          }

          let trgt =
            final_data.find((d) => {
              return d.uuid == uuid;
            }) || {};
          // console.log("final data", final_data);
          vm.$alertify.prompt(
            vm.$t("enter category name"),
            trgt.name,
            function (element, value) {
              local_api(vm, "post", "/automation/group/do-save", {
                n: value,
                u: uuid,
              })
                .then(() => {
                  vm.init();
                })
                .catch((err) => {
                  error_toast(err);
                });
            },
          );
        });

        register_listener("modul.delete_group", function (e, element) {
          let uuid = window.jQuery(element).data("uuid");
          vm.$alertify.confirm(
            vm.$t("are you sure to remove group?"),
            function () {
              local_api(vm, "post", "/automation/group/do-remove", {
                u: uuid,
              })
                .then(() => {
                  success_toast(vm.$t("group deleted"));
                  vm.init();
                })
                .catch((err) => {
                  error_toast(err);
                });
            },
          );
        });
      }, 500);
    },
    add() {
      let vm = this;
      vm.$alertify.prompt(
        vm.$t("enter group name"),
        "",
        function (element, value) {
          local_api(vm, "post", "/automation/group/do-save", {
            n: value,
          })
            .then(() => {
              vm.init();
            })
            .catch((err) => {
              error_toast(err);
            });
        },
      );
    },
  },
};
</script>
